<template>
  <v-container fluid grid-list-sm>
    <alert-error :error="error" />
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.VIEW') }} {{ $t('SERVICES.INTERNAL_SERVICE_NAME') }}
          </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn depressed class="ml-2" @click="clone">
          {{ $t('BUTTON.CLONE') }}
        </v-btn>
        <confirm-dialog ref="confirm"></confirm-dialog>

        <v-btn dark color="indigo" class="ml-2" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="
            $router.push({
              name: 'internal-service.edit',
              params: { id: id }
            })
          "
        >
          {{ $t('BUTTON.EDIT') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <v-row>
          <v-col md="8" xs="12">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.title"
                  name="title"
                  :counter="65"
                  :label="`${$t('ITEM.TITLE')} *`"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card outlined :loading="loading">
                  <v-card-text>
                    <v-tabs v-model="tab">
                      <v-tab v-for="language in languages" :key="language.id">
                        {{ language.name }}
                      </v-tab>

                      <v-tabs-items v-model="tab">
                        <v-tab-item
                          v-for="(language, index) in languages"
                          :key="language.id"
                          eager
                        >
                          <v-card flat>
                            <v-card-text>
                              <main-form
                                v-model="form.translations[index]"
                                :language-id="language.id"
                                :locale="lang"
                                :readonly="true"
                              ></main-form>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-tabs>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="4" xs="12">
            <v-card outlined :loading="loading">
              <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <v-subheader>{{ $t('ITEM.TYPE') }}</v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-row dense>
                      <v-col cols="6">
                        <v-subheader>{{
                          $t('SERVICES.SERVICE_NAME')
                        }}</v-subheader>
                      </v-col>
                      <v-col cols="6">
                        <group-select
                          v-model="form.group"
                          name="group"
                          readonly
                          :label="`${$t('ITEM.GROUP')} *`"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-subheader>{{ $t('HOLIDAY.ITEMS') }}:</v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-checkbox
                      v-model="form.is_eliminate_tasks"
                      :label="$t('SERVICES.ELIMINATE_TASKS')"
                      readonly
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GroupSelect from '@/modules/services/components/GroupSelect';

export default {
  name: 'InternalServiceShowPage',

  components: {
    GroupSelect,
    MainForm: () => import('../../components/MainForm'),
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    tab: null,
    error: null,
    errors: [],
    languages: [],
    form: {
      translations: [],
      price: 1,
      is_on_request: 0,
      is_eliminate_tasks: true
    }
  }),

  computed: {
    ...mapGetters('localization', ['lang']),
    ...mapGetters(['loading'])
  },

  created() {
    this.retrieveLanguages()
      .then(response => {
        this.languages = response.data;

        this.retrieveInternalService(this.id).then(({ data }) => {
          this.initForm(data);
        });
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    ...mapActions('service', ['cloneService']),
    ...mapActions('service', ['retrieveInternalService']),
    ...mapActions('localization', ['retrieveLanguages']),
    initForm(data) {
      const translations = [];

      this.languages.forEach((language, index) => {
        translations[index] = data.translations.find(
          translation => translation.language_id === language.id
        );
      });

      this.form = { ...this.form, ...data, translations };
    },

    clone() {
      this.$refs.confirm
        .open(this.$t('SERVICES.CLONE_QUESTION'))
        .then(confirm => {
          if (confirm) {
            this.cloneService(this.id)
              .then(() => {
                this.$router.push({ name: 'services' });
              })
              .catch(({ response }) => {
                this.handleErrorsByResponse(response);
              });
          }
        });
    }
  }
};
</script>
